import { createRoute, useNavigate } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

/**
 * `/admin/email/new` — template creation editor addressable by URL
 * (campaign #15b). Previously a local signal (`creating`) without own URL.
 * Static segment: wins over `$templateId` in router.
 */
function AdminEmailNewPage() {
  const navigate = useNavigate();
  const back = () => {
    void navigate({ to: "/admin/email" });
  };
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        mode={() => "new"}
        onClose={back}
        onNew={back}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailNewRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/new",
  component: AdminEmailNewPage,
});
